import { makeStyles } from '@mui/styles';

const useCustomTooltipStyles = makeStyles({
	root: {
		position: 'relative',
		'&:hover $tooltip': {
			display: 'block',
		},
	},
	tooltip: {
		'&:not(:empty)': {
			backgroundColor: '#6D6D6D',
			borderRadius: 4,
			color: 'white',
			display: 'none',
			fontFamily: 'Montserrat',
			fontSize: 10,
			width: '150px',
			padding: '4px 8px',
			position: 'absolute',
			right: 0,
			textAlign: 'center',
			top: 'calc(100% - 57px)',
			transform: 'translateX(25%)',
			zIndex: 5500,
		},
	},
});

export default useCustomTooltipStyles;
